import Comedec from "components/templates/comedec/Comedec";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "COMEDEC",
  label: "Comedec",
  Component: Comedec,
  initialContents: [
    {
      key: "dynamicPart",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
    {
      key: "dynamicPart2",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
  ],
};
